// React-side mirror of global_src/js/utils/privacy.js (the checkout bundle
// can't import from global_src). Values MUST match the storage keys the CMP
// guard (global_consent_guard.liquid) reads/writes.
export const CMP_CATEGORIES = Object.freeze({
  NECESSARY: 'necessary',
  THIRD_PARTY: 'third_party',
  MARKETING: 'marketing',
})

// True when a consent category is allowed to run. When the CMP guard isn't
// present (accounts without the consent layer) everything is allowed, so
// behaviour is identical to before the CMP existed.
export const isCategoryAllowed = (category: string): boolean => {
  if (!window.ScvrCmpConsent) return true
  return window.ScvrCmpConsent.hasCategory(category)
}
